<app-header />
<div class="col pb-3 px-3 main_body">
    <router-outlet />
</div>
